import React from 'react';
import { Dumbbell, Brain, Users, Sparkles } from 'lucide-react';
import useScrollAnimation from '../hooks/useScrollAnimation';

const ServiceCard = ({ service, index }) => {
  const [cardRef, cardVisible] = useScrollAnimation();
  
  return (
    <div 
      ref={cardRef}
      className={`network-card service-card animate-on-scroll animate-delay-${Math.min(index + 1, 4)} ${cardVisible ? 'is-visible' : ''}`}
    >
      <div className="service-icon">{service.icon}</div>
      <h3 className="network-card-title">{service.title}</h3>
      <p className="network-card-content">{service.description}</p>
      <ul className="service-features">
        {service.features.map((feature, idx) => (
          <li key={idx}>{feature}</li>
        ))}
      </ul>
    </div>
  );
};

export const Services = () => {
  const [titleRef, titleVisible] = useScrollAnimation();
  const [ctaTitleRef, ctaTitleVisible] = useScrollAnimation();

  const services = [
    {
      icon: <Dumbbell size={32} />,
      title: 'Functional Fitness',
      description: 'Build sustainable strength through movement patterns that serve your daily life. No ego lifting, just practical power.',
      features: [
        'Movement pattern mastery',
        'Strength & conditioning',
        'Mobility work',
        'Injury prevention'
      ]
    },
    {
      icon: <Brain size={32} />,
      title: 'Mindset Mastery',
      description: 'Clear your mind, regulate your nervous system, and develop the mental resilience that transforms everything.',
      features: [
        'Nervous system regulation',
        'Mental clarity practices',
        'Stress management',
        'Performance psychology'
      ]
    },
    {
      icon: <Users size={32} />,
      title: 'Corporate Programs',
      description: 'Transform your workplace culture with holistic wellness programs designed to bring work environments back to balance through work-life integration.',
      features: [
        'Corporate wellness workshops',
        'Team building & cohesion',
        'Work-life balance strategies',
        'Stress management for teams'
      ]
    },
    {
      icon: <Sparkles size={32} />,
      title: 'Spiritual Integration',
      description: 'Connect deeper. Move with purpose. Build from the inside out through practices that honor your whole being.',
      features: [
        'Mind-body-spirit alignment',
        'Breathwork & meditation',
        'Purpose discovery',
        'Holistic wellbeing'
      ]
    }
  ];

  return (
    <section id="services" className="services-section">
      <div className="container">
        <div className="section-header">
          <h2 
            ref={titleRef}
            className={`display-medium animate-slide-up ${titleVisible ? 'is-visible' : ''}`}
          >
            Real Foundations, Lasting Results
          </h2>
          <p className="body-large section-subtitle">
            My work blends functional fitness, nervous system awareness, mindset mastery 
            and deeper spiritual integration. This is about sustainable strength, not short-term hype.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <ServiceCard key={index} service={service} index={index} />
          ))}
        </div>

        <div className="service-cta">
          <img 
            src="https://customer-assets.emergentagent.com/job_heath-wellbeing/artifacts/2p45hpvk_IMG_6779.jpeg"
            alt="Team collaboration and support"
            className="service-image"
          />
          <div className="service-cta-content">
            <h3 
              ref={ctaTitleRef}
              className={`heading-2 animate-slide-left ${ctaTitleVisible ? 'is-visible' : ''}`}
            >
              Ready to Build From the Inside Out?
            </h3>
            <p className="body-large">
              Whether you're rebuilding, refining, or rising into your next level — 
              let's create a path that works for you.
            </p>
            <a 
              href="https://wa.me/61478694929"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary btn-large"
            >
              Book Your Consultation
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
